import React from "react"
import PSESectionOutputWrapper from "../PSESectionOuptut"
import ProductionStepExecutionCardContainer from "../productionStepExecutionInProgressCases/ProductionStepExecutionCardContainer"
import { makeStyles } from "@mui/styles"
import { COLORS, roundNumber } from "../../../utils"

const useStyles = makeStyles({
    root: {
        border: `1px solid ${COLORS.BLACK_200}`,
        padding: "24px",
        gap: "24px",
        borderRadius: "8px"
    },
    label: {
        color: COLORS.BLACK800,
        fontSize: 20,
        fontWeight: 500,
        lineHeight: "28px"
    },
    iconContainer: {
        height: 52,
        width: 52,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F5F5F5",
        borderRadius: "8px",
    },
    icon: { width: 24, height: 24 },
    row: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 8,
    },
    recipeLabel: {
        color: COLORS.BLACK800,
        fontSize: 18,
        fontWeight: 400,
    },
    weightColLabel: {
        color: "#555",
        fontSize: 16,
        fontWeight: 400,
        lineHeight: "24px",
        marginBottom: 4,
    },
    weightColValue: {
        color: COLORS.BLACK800,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: "24px",
    },
    weightsBlock: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 32,
        flexShrink: 0,
        marginLeft: 24,
    },
    sectionField: {
        color: COLORS.DRAFT_GREY,
        margin: 0,
        fontWeight: 400,
        fontSize: 14,
    },
})

const PSESectionOuptutRecap = ({ productionStepExecution }) => {
    const classes = useStyles()
    const isStepMerged = !!(productionStepExecution.isStepMerged || productionStepExecution.mergedProductionStepExecutions?.length > 0)
    const mergedPSEs = productionStepExecution.mergedProductionStepExecutions || []
    const sectionName = mergedPSEs[0]?.sectionName

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {/* Répartition par recette — readOnly, merged PSEs only */}
            {isStepMerged && mergedPSEs.length > 0 && (
                <div className={classes.root}>
                    <div style={{ display: "flex", flexDirection: "row", gap: 12, alignItems: "center", marginBottom: 16 }}>
                        <div className={classes.iconContainer}>
                            <img className={classes.icon} src="/img/recipes/balance.svg" alt="balance" />
                        </div>
                        <span className={classes.label}>Répartition des poids par recette</span>
                    </div>
                    {mergedPSEs.map((pse) => (
                        <div key={pse.objectId} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                            <div>
                                <div className={classes.recipeLabel}><b>{pse.uniqueCode}</b> - {pse.recipeName}</div>
                                {sectionName && <p className={classes.sectionField}>({sectionName})</p>}
                            </div>
                            <div className={classes.weightsBlock}>
                                <div>
                                    <div className={classes.weightColLabel}>Poids prévu</div>
                                    <div className={classes.weightColValue}>{roundNumber(pse.theoreticalNetWeight, 2)} kg</div>
                                </div>
                                <div>
                                    <div className={classes.weightColLabel}>Poids attribué</div>
                                    <div className={classes.weightColValue}>
                                        {pse.productionStepExecution?.netWeight != null
                                            ? `${roundNumber(pse.productionStepExecution.netWeight, 2)} kg`
                                            : "—"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Répartition des poids par partie — sectionOutputs */}
            <ProductionStepExecutionCardContainer
                title="Répartition des poids par partie"
                icon="/img/recipes/balance.svg"
                readOnly
            >
                <PSESectionOutputWrapper
                    values={{ sectionOutputWeights: productionStepExecution.sectionOutputWeights ?? {} }}
                    readOnly
                    productionStepExecution={productionStepExecution}
                />
            </ProductionStepExecutionCardContainer>
        </div>
    )
}
export default PSESectionOuptutRecap